import { State } from 'src/redux';

export const getKeyValuesStores = (state: State) => state.keyValues.stores;

export const getKeyValuesItems = (state: State) => state.keyValues.items;
